export default __webpack_public_path__ + "static/media/no-result.f0adb046.svg";